import { useState } from "react";
import { FileDown } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { api, handleErr } from "../lib/api";

const thisMonth = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; };

export const ReportButton = ({ path = "/reports/monthly", params = {}, testId = "monthly-report" }) => {
  const [month, setMonth] = useState(thisMonth());
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get(path, { params: { ...params, month }, responseType: "blob" });
      const name = (res.headers["content-disposition"] || "").match(/filename="(.+)"/)?.[1] || `NamoAI-report-${month}.pdf`;
      const a = document.createElement("a");
      a.href = URL.createObjectURL(res.data);
      a.download = name;
      a.click();
    } catch (e) {
      if (e.response?.data instanceof Blob) e.response.data = JSON.parse(await e.response.data.text());
      handleErr(e);
    } finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-2">
      <Input data-testid={`${testId}-month`} type="month" value={month} max={thisMonth()} onChange={(e) => setMonth(e.target.value)} className="w-40 h-9 [color-scheme:dark]" />
      <Button data-testid={`${testId}-btn`} size="sm" disabled={busy || !month} onClick={download} className="rounded-full h-9"><FileDown size={15} className="mr-1.5" />{busy ? "Building..." : "Monthly PDF"}</Button>
    </div>
  );
};
